import { Component } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
	selector: 'fn-grid-img',
	templateUrl: 'fn-grid-img.component.html',
	styleUrls: ['fn-grid-img.component.scss'],
})
export class FnGridImgComponent extends FnGridAbstractCell {}
